<!--
 * @Author: zl
 * @Date: 2022-04-24 10:43:35
 * @LastEditTime: 2023-01-13 14:37:42
 * @LastEditors: zl
 * @Description: 形象进度
-->
<template>
	<div class="VisualProcess-layout filter-layout">
		<div class="filter-box pdt10">
			<!-- 头部标题 -->
			<h3 class="text-center pdt10 pdb10">东部新中心建设项目形象进度表
				<el-tooltip effect="light"
							placement="bottom-start">
					<svg-icon icon-class="wenhao"
							  class="custom-svg"
							  style="color:#888"></svg-icon>
					<template slot="content">
						<div v-html="titleTip"></div>
					</template>
				</el-tooltip>
			</h3>
			<!-- 上方合计表格： -->
			<div class="filter-content primary-layout">
				<!-- 表头搜索区 -->
				<div class="primary-header ">
					<div class="left-text">
						筛选时间统计：{{ tableObj.filterTime }}
					</div>
					<div class="left-text">
						<span>
							选择月份
							<el-date-picker type="month"
											size="mini"
											placeholder="请选择"
											value-format="yyyy-MM"
											:clearable='false'
											v-model="searchForm.attributionMon"
											@change="choiceMonth">
							</el-date-picker>
						</span>

						<!-- <el-button icon="el-icon-menu"
								   type="primary"
								   size="mini"
								   @click="doFilter('top', '1098003')">列过滤</el-button> -->
						<el-button size="mini"
								   @click="exportExcelMethod('total')">导出Excel</el-button>
					</div>
				</div>
				<!-- 合计表格 -->
				<div class="content-table">
					<vxe-table align="center"
							   header-align="center"
							   height="220px"
							   auto-resize
							   border
							   ref="topTable"
							   :cell-class-name="cellStyle"
							   :loading="tableObj.totalLoading"
							   :data="tableObj.totalTable"
							   @cell-click="cellClick"
							   show-overflow="tooltip"
							   show-header-overflow="tooltip"
							   :header-cell-style="headerCellStyle"
							   :row-class-name="rowClassName">
						<vxe-column field="isNorth"
									title="片区"
									width="130"></vxe-column>
						<vxe-colgroup v-for="item in tableList"
									  :title="item.sname"
									  :key="item.id"
									  :field="item.field"
									  header-class-name="custom-table-height"
									  class="custom-cell">
							<template #header
									  v-if="item.needTemplate">
								{{ item.sname }}
								<el-tooltip placement="bottom-start"
											effect="light">
									<template slot="content">
										<p>进展状态数据统计说明：</p>
										<p class="mt15">1.根据本年度项目设定范围该项目形象进度填报的状态：</p>
										<p>
											在选择月份下，当用户填报了归属月份为该月份的进展状态时，则纳入填报状态统计，<br>
											根据实际填报情况回显进展状态。
										</p><br>
										<p>2.当项目计划开工时间比查询月份晚，且归属月份未填报时则纳入持平项目。</p><br>
										<p>3.当项目计划开工时间等于查询月份，且归属月份未填报时则纳入滞后项目。</p><br>
										<p>4.当项目计划开工时间比查询月份早，且归属月份未填报时则纳入滞后项目。</p><br>
										<p>5.前一年竣工的项目本年不纳入统计。</p>
									</template>
									<svg-icon icon-class="wenhao"></svg-icon>
								</el-tooltip>
							</template>
							<template #default="{ row }"
									  v-if="item.fieldId == 'totalId'">
								<span class="vxe-cell--label custom-cell">
									<strong>{{ row[item.field] }}</strong>
								</span>
							</template>
							<vxe-column v-for="n in item.children"
										:key="n.id"
										:title="n.sname"
										:field="n.field"
										header-align="center"
										align="right"
										header-class-name="custom-table-height">
								<template #default="{ row }">
									<span class="vxe-cell--label custom-cell">
										<strong>{{ row[n.field] }}</strong>
									</span>
								</template>
							</vxe-column>
						</vxe-colgroup>
					</vxe-table>
				</div>
			</div>
		</div>
		<!-- 下方详情表格： -->
		<div class="filter-content primary-layout margin-top25 bottom-layout">
			<!-- 表头搜索区 -->
			<div class="primary-header">
				<div class="left-text">
					<span class="tips">
						<i class="el-icon-warning"></i>
						<span v-html="this.customTip()"></span>
					</span>
				</div>
				<div class="btnGroups">
					<el-input v-model="searchForm.sname"
							  size="small"
							  placeholder="请输入项目名称"
							  clearable
							  class="custom-input-inner">
						<el-button class="btn-success"
								   size="small"
								   slot="append"
								   @click="submitForm">查询</el-button>
					</el-input>
					<!-- 弹出框搜素区域 -->
					<el-popover placement="bottom-end"
								width="415"
								trigger="click">
						<el-form ref="searchForm"
								 :model="searchForm"
								 size="small"
								 label-width="100px">
							<el-form-item label="项目类型"
										  prop="newProType">
								<el-select v-model="searchForm.newProType"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in projectDict.dxxmlx"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="建设单位"
										  prop="constructionUnit">
								<el-select v-model="searchForm.constructionUnit"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="(item, index) in constructionUnitList"
											   :key="index"
											   :label="item.sname"
											   :value="item.ownerUnit"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label-width="0"
										  class="text-center borderTop">
								<el-button type="primary"
										   icon="el-icon-search"
										   @click="submitForm">查询</el-button>
								<el-button icon="el-icon-refresh"
										   @click="resetForm">重置</el-button>
							</el-form-item>
						</el-form>
						<el-button size="small"
								   icon="el-icon-arrow-down"
								   slot="reference"
								   class="ml10 mr10 btn-success"></el-button>
					</el-popover>

					<el-button icon="el-icon-menu"
							   type="primary"
							   size="small"
							   @click="doFilter('bottom', '1098004')">列过滤</el-button>
					<el-button size="small"
							   @click="exportExcelMethod('list')">导出Excel</el-button>
				</div>
			</div>
			<div class="primary-select">
				<span class="title">节点进度展开/折叠列:</span>
				<div class="ml10">
					<el-checkbox v-model="selectAll"
								 style="margin-right: 0"
								 @change="selectAllChange">全选</el-checkbox>
					<span class="ml10 mr10"
						  style="color:#e4e4e4">|</span>
					<el-checkbox v-for="item in nodeProgressList"
								 :key="item.id"
								 v-model="item.check"
								 @change="selectSingleChange($event, item)">{{ item.sname }}</el-checkbox>
				</div>
			</div>
			<!-- 详情表格 -->
			<div class="primary-content">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="tableObj.data"
								   highlight-hover-row
								   highlight-current-row
								   height="100%"
								   :loading="tableObj.loading"
								   ref="progressTable"
								   show-header-overflow="tooltip"
								   show-overflow="tooltip">
							<vxe-column title="序号"
										type="seq"
										width="65"></vxe-column>
							<vxe-column title="项目名称"
										field="sname"
										width="250px"
										header-align="center"
										align="left">
								<template #default="{ row }">
									<span class="vxe-cell--label blue-text"
										  @click="doClick(row, 'enter')">
										{{ row.sname }}
									</span>
								</template>
							</vxe-column>
							<vxe-column title="片区"
										field="areaname"
										width="120px"></vxe-column>
							<vxe-column title="建设单位"
										field="constructionUnitName"
										min-width="150px"
										header-align="center"
										align="left"
										:visible="false">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.constructionUnitName"
												placement="top">
										<span class="vxe-cell--label">{{ row.shortName }}</span>
									</el-tooltip>
								</template>
							</vxe-column>
							<vxe-column title="计划编排类别"
										field="planType"
										width="120px"
										:visible="false"></vxe-column>
							<vxe-column title="项目类型"
										field="newProTypeName"
										width="120px"
										:visible="false"></vxe-column>
							<vxe-column title="建设类型"
										field="constructionTypeName"
										width="120px"
										:visible="false"></vxe-column>
							<vxe-column title="争取开工年份"
										field="striveStartDate"
										width="120px"
										:visible="false"></vxe-column>
							<vxe-column title="进展状态"
										field="stateName"
										width="120px">
								<template #default="{ row }">
									<span class="vxe-cell--label"
										  :class="className[row.state]">
										{{ row.stateName }}
									</span>
								</template>
							</vxe-column>
							<vxe-column title="归属月份"
										field="attributionMon"
										width="120px"></vxe-column>
							<vxe-column title="总进度描述"
										field="progressDescription"
										width="120px"></vxe-column>
							<vxe-column title="最后更新人"
										field="updateUseridname"
										width="120px"></vxe-column>
							<vxe-column title="最后更新日期"
										field="updateDate"
										width="120px">
								<template #default="{ row }">
									<el-tooltip :content="row.updateDate"
												placement="top"
												effect="light"
												v-if="row.updateDate != '-'">
										<span>{{ row.updateDate.substring(0, 10) }}</span>
									</el-tooltip>
									<span v-else>{{ row.updateDate }}</span>
								</template>
							</vxe-column>
							<vxe-colgroup v-for="item in headerList"
										  :key="item.id + 'bottom'"
										  :title="item.sname"
										  :field="item.id"
										  header-class-name="custom-table-height"
										  :visible="item.visible"
										  class="custom-cell"
										  min-width="150px">
								<template #default="{ row }"
										  v-if="!item.isChildren">
									<span class="vxe-cell--label">
										<svg-icon v-if="row[item.id] != '-'"
												  :icon-class="customIconClass(row[item.id], 'icon')"
												  :class="customIconClass(row[item.id], 'class')"
												  class="mr5"></svg-icon>{{ row[item.id] }}
									</span>
								</template>
								<vxe-column v-for="n in item.children"
											:key="n.id"
											:title="n.sname"
											:field="n.id"
											:visible="item.visible"
											header-align="center"
											min-width="160px"
											header-class-name="custom-table-height">
									<template #default="{ row }">
										<span class="vxe-cell--label">
											<svg-icon v-if="row[n.id] != '-'"
													  :icon-class="customIconClass(row[n.id], 'icon')"
													  :class="customIconClass(row[n.id], 'class')"
													  class="mr5"></svg-icon>{{ row[n.id] }}
										</span>
									</template>
								</vxe-column>
							</vxe-colgroup>
							<vxe-column title="操作"
										min-width="180px">
								<template #default="{ row }">
									<el-button type="primary"
											   round
											   plain
											   class="table-btn"
											   v-if="roleBtns.includes('view')"
											   :disabled="row.id == null ? true : false"
											   @click="doClick(row, 'view')">
										<svg-icon icon-class="form-look"></svg-icon> 查看
									</el-button>
									<el-button type="primary"
											   round
											   plain
											   class="table-btn"
											   v-if="roleBtns.includes('enter')"
											   @click="doClick(row, 'enter')">
										<svg-icon icon-class="form-enter"></svg-icon> 进入项目
									</el-button>
								</template>
							</vxe-column>
						</vxe-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 查看弹窗 -->
		<el-dialog title="项目进度"
				   :visible.sync="dialogObj.show"
				   width="1000px"
				   :close-on-click-modal="false"
				   top="7vh"
				   center
				   @close="dialogClose">
			<el-form :model="dialogObj.form"
					 size="mini"
					 label-width="110px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="项目名称：">
							{{ dialogObj.form.projectIdName }}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="归属月份：">
							{{ dialogObj.form.attributionMon }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="进展状态：">
							{{ dialogObj.form.stateName }}
						</el-form-item>
					</el-col>
					<template>
						<el-col :span="12">
							<el-form-item :label="dialogObj.form.stateName+'月份：'">
								{{ dialogObj.form.stateDescribe }}
							</el-form-item>
						</el-col>
					</template>
					<el-col :span="24">
						<el-form-item label="进度描述：">
							{{ dialogObj.form.progressDescription }}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="附件：">
							<myUpload listType="list"
									  v-if="dialogObj.show"
									  tableName="audit_project_schedule"
									  assortment="test2"
									  width="auto"
									  height="auto"
									  :aid="dialogObj.form.id"
									  mode="view"
									  class="w100"></myUpload>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作人：">
							{{ dialogObj.form.updateUserName }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作单位：">
							{{ dialogObj.form.updateTenantName }}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="操作时间：">
							{{ dialogObj.form.updateDate }}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  :busType="busType"
					  memory
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getContainerParams } from '@/api/home/homeIndex'
import * as ProjectApi from 'api/projectManage/ProjectIndex'
import * as API from 'api/Progress/ProgressIndex'
import * as HomeApi from '@/api/home/homeIndex'
import FileName from '@/components/file/fileName'
import ColumnFilter from '@/views/Common/ColumnFilter'
import TextTooltip from '@/views/Common/TextTooltip'
import { exportExcel } from 'utils/tools'
export default {
	name: 'ProgressIndex',
	components: { FileName, ColumnFilter, TextTooltip },
	data() {
		return {
			tableObj: {
				filterTime: '', // 筛选时间
				totalTable: [], // 上方表格-合计
				totalLoading: false, //上方表格loading

				data: [], // 下方表格-展示详细情况
				loading: false, // 下方表格loading

				// 分页:
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			searchForm: {
				attributionMon: '', // 选择月份
				sname: '', // 查询项目（项目名称）
				newProType: '', //项目类型
				constructionUnit: '', //建设单位
				projectId: '', // 项目id
				area: [], //片区
				status: '',
			},
			constructionUnitList: [], //建设单位列表
			// 详情表格查看弹窗
			dialogObj: {
				show: false,
				form: {},
				activeName: ['1', '2'],
				historyData: [],
			},
			selectRowIndex: 1, // 点击单元格的rowIndex
			selectColumnIndex: 1, // 点击单元格的columnIndex
			showFilter: false, //列过滤弹窗显隐
			selectField: '', //点击单元格的 field
			selectFieldIds: 'totalId', //点击单元格 对应 参数
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			filterColumn: {}, //点击的当前列
			isNorth: '', // 区域
			state: '',
			formName: '',
			area: '',
			className: {
				1096001: 'operating', // 提前
				1096002: 'toProcess', // 持平
				1096003: 'toRejected', // 滞后
			},
			totalNum: '',
			busType: '', //用以区分略过滤模块
			nodeProgressList: [],
			headerList: [],
			selectAll: true,
		}
	},
	created() {
		// 获取当前时间
		this.getContainerParams()
		// 根据单位类型查询单位
		this.getCompanyList()
		// 获取自定义列过滤 形象进度合计表
		// this.getSelfData('1098003', false)
		// 获取自定义列过滤 形象进度项目表
		this.getSelfData('1098004', false)
		// 获取节点进度
		this.accessNodeProgress()
	},
	methods: {
		// 获取当前时间(后台)
		getContainerParams() {
			getContainerParams({}).then((res) => {
				let year = parseInt(res.data.currentDate.substr(0, 4))
				let month = parseInt(res.data.currentDate.substr(5, 2))
				let day = parseInt(res.data.currentDate.substr(8, 2))
				if (day <= 25) {
					if (month == 1) {
						this.searchForm.attributionMon = year - 1 + '-' + '12'
					} else if (1 < month && month < 10) {
						this.searchForm.attributionMon =
							year + '-' + '0' + (month - 1)
					} else {
						this.searchForm.attributionMon =
							year + '-' + (month - 1)
					}
				} else {
					this.searchForm.attributionMon = year + '-' + month
				}
				if (this.projectDict && this.projectDict.xmgsqy) {
					this.searchForm.area = this.projectDict.xmgsqy.map(
						(x) => x.value
					)
					this.searchForm.constType = this.projectDict.dxjslx.map(
						(x) => x.value
					)
					this.searchForm.stateDescribe = this.projectDict.jzzt.map(
						(x) => x.value
					)
				}
				this.tableObj.filterTime = this.searchForm.attributionMon
				this.selectSchedulestatistics(true)
			})
		},

		// 获取自定义列过滤数据
		getSelfData(busType, first) {
			let params = { busType }
			let loadingName = busType == '1098003' ? 'totalLoading' : 'loading'
			let refName = busType == '1098003' ? 'topTable' : 'progressTable'
			let column = busType == '1098003' ? 'fullColumn' : 'collectColumn'
			this.tableObj[loadingName] = true
			HomeApi.getSelfData(params)
				.then((res) => {
					if (res.data.length == 0) {
						return
					}
					if (this.$refs[refName]) {
						let tableShowColumn =
							this.$refs[refName].getTableColumn()
						tableShowColumn[column].forEach((x) => {
							let obj = res.data.find(
								(y) => y.field == x.property
							)
							if (obj) {
								x.visible = obj.isChecked
							}
						})
						this.$refs[refName].refreshColumn()
					}
					this.tableObj[loadingName] = false
					if (first) {
						this.selectRowIndex = 1
						this.selectColumnIndex = 1
						this.filterColumn.parentId = null
						this.selectSchedulestatistics(true)
					}
				})
				.catch(() => {
					this.tableObj[loadingName] = false
				})
		},

		// 获取保存的节点进度数据
		getProgressSaveData() {
			HomeApi.getSelfData({
				busType: '1098011',
			}).then((res) => {
				let arr = res.data.map((x) => x.isChecked)
				let isSeleceAll = arr.filter((x) => x != '1')
				this.selectAll = isSeleceAll.length > 0 ? false : true
				this.nodeProgressList.forEach((x, index) => {
					x.check = arr[index] == '1' ? true : false
				})
				this.headerList.forEach((x, index) => {
					x.visible = arr[index] == '1' ? true : false
				})
				this.tableObj.loading = true
				setTimeout(() => {
					this.$refs.progressTable.refreshColumn()
					this.tableObj.loading = false
				}, 500)
			})
		},

		// 获取统计报表数据
		selectSchedulestatistics(first) {
			this.tableObj.totalLoading = true
			API.selectSchedulestatistics({
				mon: this.searchForm.attributionMon,
			})
				.then((res) => {
					this.tableObj.totalTable = res.data || []
					this.tableObj.totalLoading = false
					// 首次进入赋予瑶海区-合计的id
					if (first) {
						this.searchForm.projectId = res.data[1].totalId
						this.selectField = 'total'
						// 锁定 瑶海区 合计单元格 并清空 当前操作的filed
						this.isNorth = '瑶海区'
					} else {
						this.searchForm.projectId =
							this.tableObj.totalTable[this.selectRowIndex][
								this.selectFieldIds
							]
					}
					if (res.data[1].total == '0') {
						this.totalNum = 0
						this.tableObj.data = []
						this.tableObj.loading = false
					} else {
						this.getProgressData()
					}
				})
				.catch(() => {
					this.tableObj.totalLoading = false
				})
		},

		// 获取形象进度列表数据
		getProgressData() {
			this.tableObj.loading = true
			let params = this.$utils.clone(this.searchForm, true)
			delete params.area
			delete params.constType
			delete params.stateDescribe
			API.getProjectScheduleData(params)
				.then((res) => {
					if (this.searchForm.projectId == '') {
						this.tableObj.data = []
						this.totalNum = 0
					} else {
						this.tableObj.data = res.data || []
						this.tableObj.total = res.data.length
						this.totalNum = res.data.length
					}
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 获取节点进度
		accessNodeProgress() {
			API.selectTree({}).then((res) => {
				this.nodeProgressList = this.$utils.clone(res.data, true)
				this.headerList = this.$utils.clone(res.data, true)
				this.nodeProgressList.forEach((x) => {
					x.check = true
					if (x.sname == '监理招投标文件') {
						x.sname = '监理招标'
					}
					if (x.sname == '施工招投标文件') {
						x.sname = '施工招标'
					}
				})
				this.headerList.forEach((x) => {
					x.visible = false
				})
				// 获取保存的节点进度数据
				this.getProgressSaveData()
			})
		},

		// 全选change
		selectAllChange(data) {
			this.nodeProgressList.forEach((x) => (x.check = data))
			this.headerList.forEach((x) => {
				x.visible = data
				this.tableObj.loading = true
				setTimeout(() => {
					this.$refs.progressTable.refreshColumn()
					this.tableObj.loading = false
				}, 200)
			})
			// 节点进度change保存
			this.saveProgress()
		},

		// selectchange
		selectSingleChange(data, item) {
			this.$forceUpdate()
			let arr = this.nodeProgressList.filter((x) => !x.check)
			this.selectAll = arr.length > 0 ? false : true
			this.headerList.forEach((x) => {
				if (x.id == item.id) {
					x.visible = data
					this.tableObj.loading = true
					setTimeout(() => {
						this.$refs.progressTable.refreshColumn()
						this.tableObj.loading = false
					}, 200)
				}
			})
			// 节点进度change保存
			this.saveProgress()
		},

		// 节点进度change保存
		saveProgress() {
			let dealColumn = []
			//组装后台需要的数据格式
			this.nodeProgressList.forEach((x, index) => {
				dealColumn.push({
					name: x.sname,
					field: x.id,
					isChecked: x.check ? '1' : '0',
					index,
				})
			})
			HomeApi.saveSelfColumns({
				createUserid: this.userInfo.id,
				busType: '1098011',
				columnVisible: dealColumn,
			}).then((res) => {})
		},

		// 选择月份
		choiceMonth(data) {
			this.searchForm.status = ''
			if (!data) {
				this.tableObj.filterTime = ''
			} else {
				this.tableObj.filterTime = data
			}
			this.selectRowIndex = 1
			this.selectColumnIndex = 1
			this.filterColumn.parentId = null
			this.selectSchedulestatistics(true)
		},

		// 指定单元格赋予样式
		cellStyle({ rowIndex, column, columnIndex }) {
			if (
				rowIndex === this.selectRowIndex &&
				columnIndex === this.selectColumnIndex &&
				column.parentId == this.filterColumn.parentId
			) {
				return 'custom-active-cell'
			}
		},

		// 处理上方表格 进展状态的样式背景
		headerCellStyle({ column }) {
			if (
				column.title == '进展状态' ||
				column.title == '滞后' ||
				column.title == '提前' ||
				column.title == '持平'
			) {
				return {
					backgroundColor: '#e8f2fc',
				}
			}
		},

		// 处理上方表格 进展状态的样式背景
		rowClassName({ rowIndex }) {
			if (rowIndex == 1) {
				return 'bgcIndex1-progress'
			}
			if (rowIndex == 2) {
				return 'bgcIndex2-progress'
			}
			if (rowIndex == 3) {
				return 'bgcIndex3-progress'
			}
		},

		// 单元格被点击触发事件
		cellClick({ row, rowIndex, column, columnIndex }) {
			let field = column.field
			if (field == 'isNorth') {
				return
			}
			this.isNorth = row.isNorth
			this.searchForm.status = '1'

			// 保存当前行数据用来渲染中间的提示信息
			this.filterColumn = this.$utils.clone(column, true)

			// 保存 点击单元的 行下标 和 列下标 用来渲染 active 的样式
			this.selectRowIndex = rowIndex
			this.selectColumnIndex = columnIndex

			//存储点击单元格的field
			this.selectField = field
			let filterData = this.$utils.filterTree(
				this.tableList,
				(item) => item.field == this.selectField
			)
			// this.searchForm.projectId = ''
			if (filterData.length > 0) {
				let hangField = filterData[0].fieldId
				this.selectFieldIds = hangField
				this.searchForm.projectId = row[hangField]
				let hangField2 = filterData[0].field
				this.totalNum = row[hangField2]
				this.tableObj.total = row[hangField2]
				if (row[hangField2] == '0') {
					this.tableObj.data = []
					return
				}
				this.getProgressData()
			}
		},

		// 点击列过滤
		doFilter(type, busType) {
			this.$set(this, 'busType', busType)
			this.showFilter = true
			// 区分 table
			let refName = type == 'top' ? 'topTable' : 'progressTable'
			// 获取对应 table 的列
			let tableColumn = []
			if (type == 'top') {
				tableColumn = this.$refs[refName].getTableColumn()
				let fullColumn = this.$utils.clone(tableColumn.fullColumn, true)
				fullColumn.shift()
				fullColumn.shift()
				this.filterColumns[0].columns = fullColumn
			}
			if (type == 'bottom') {
				tableColumn = this.$refs[refName].getTableColumn()
				tableColumn.collectColumn.shift()
				for (let i = 0; i <= this.headerList.length; i++) {
					tableColumn.collectColumn.pop()
				}
				this.filterColumns[0].columns = tableColumn.collectColumn
			}

			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			let refName =
				this.busType == '1098003' ? 'topTable' : 'progressTable'
			let loadingName =
				this.busType == '1098003' ? 'totalLoading' : 'loading'
			this.tableObj[loadingName] = true
			if (this.$refs[refName]) {
				this.$set(this, 'filterColumns', arr)
				this.getSelfData(this.busType, false)
				return
			}
			this.tableObj[loadingName] = false
		},

		// 根据单位类型查询单位
		getCompanyList() {
			ProjectApi.selectSysTenantsByType().then((res) => {
				this.$set(this, 'constructionUnitList', res.data.SUBJECT_JSDW)
			})
		},

		// 表单搜索
		submitForm() {
			// this.tableObj.currentPage = 1
			this.getProgressData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.tableObj.currentPage = 1
			this.searchForm.sname = ''
			this.getProgressData()
		},

		// 表格按钮点击事件
		doClick(data, type) {
			if (type == 'enter') {
				if (!this.roleBtns.includes('enter')) {
					return
				}
				let url = this.$outUrl
				let token = this.$getSessionItem('token')
				let tenantId = this.$getSessionItem('tenantId')
				let limitId = this.$getSessionItem('limitId')
				ProjectApi.getAuditWorkPower({
					projectId: data.projectId,
				}).then((res) => {
					if (res.operationCode == 1 && res.msg == 'faild') {
						this.$message.warning(res.data)
						return
					}
					window.open(
						`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
						'_blank'
					)
				})
				return
			}
			this.dialogObj.show = true
			this.dialogObj.form = this.$utils.clone(data, true)
			// this.getStoryInfo(data)
			this.getProjectScheduleInfo(data)
		},

		// 获取 查看 表单详情
		getProjectScheduleInfo(data) {
			API.getProjectScheduleInfo({
				uid: data.id,
			}).then((res) => {
				this.dialogObj.form = res.data
			})
		},

		// 获取修改历史记录
		// getStoryInfo(data) {
		// 	API.getProjectScheduleInfo({
		// 		uid: data.id,
		// 	}).then((res) => {
		// 		this.dialogObj.historyData = res.data
		// 	})
		// },

		// 弹窗关闭
		dialogClose() {
			this.dialogObj.show = false
			this.dialogObj.form = {}
			this.dialogObj.historyData = []
		},

		// 处理提示语
		customTip() {
			let area = ''
			let formName = '合计'
			let msg = ''
			let filterData = this.$utils.filterTree(
				this.tableList,
				(item) => item.field == this.selectField
			)
			if (filterData.length > 0) {
				let data = filterData[0]
				if (this.isNorth == '合计' && data.sname == '合计(项目数)') {
					area = ''
					formName = '合计'
				} else {
					if (data.sname == '合计(项目数)') {
						formName = data.parentName + data.sname.substr(0, 2)
					} else {
						formName = data.parentName + data.sname
					}
					area = this.isNorth
				}
			}
			msg = `统计期内${area}${formName}项目数：${this.totalNum}个`
			return msg
		},

		// 导出excel
		exportExcelMethod(type) {
			let tableData =
				type == 'list' ? this.tableObj.data : this.tableObj.totalTable
			let params = {
				selectYear: this.tableObj.filterTime, //统计时间
				excelData: tableData, //导出数据集合
			}
			let baseUrl =
				type == 'list'
					? '/auditschedule/exportScheduleExcel'
					: '/auditschedule/exportExcel'
			let url = process.env.VUE_APP_BASE_URL + baseUrl
			let fileName =
				type == 'list'
					? '东部新中心建设项目形象进度表'
					: '东部新中心建设项目形象进度报表统计'
			exportExcel(url, params, fileName)
		},

		// 自定义icon-class
		customIconClass(data, type) {
			let msg = ''
			const arr1 = ['不涉及']
			const arr2 = [
				'未启动',
				'尚未交付',
				'尚未准备',
				'尚未验收',
				'尚未施工',
				'未开工',
				'尚未备案',
			]
			const arr3 = [
				'正编制招标文件',
				'正勘察',
				'正在编制',
				'正在办理',
				'正编制',
				'正进行',
				'正协商',
				'正组卷',
				'正拆除',
				'正在准备',
				'正在施工',
				'正在验收',
				'正在备案',
			]
			const arr4 = [
				'已挂网',
				'已报审',
				'已公告',
				'已报批',
				'已申请',
				'准备完成',
				'验收完成',
				'暂未办理',
			]
			const arr5 = [
				'已招标',
				'已勘察',
				'已批复',
				'办理完成',
				'已批复',
				'公告完成',
				'已完成',
				'已签订',
				'已获批',
				'已拆除',
				'已完成',
				'已开工',
				'施工完成',
				'备案完成',
				'已交付',
				'已启动',
			]
			if (arr1.includes(data)) {
				msg = type == 'icon' ? 'form-bsj' : 'icon-1'
			}
			if (arr2.includes(data)) {
				msg = type == 'icon' ? 'form-wqd' : 'icon-2'
			}
			if (arr3.includes(data)) {
				msg = type == 'icon' ? 'form-bzzbwj' : 'icon-3'
			}
			if (arr4.includes(data)) {
				msg = type == 'icon' ? 'form-ygw' : 'icon-4'
			}
			if (arr5.includes(data)) {
				msg = type == 'icon' ? 'form-yzb' : 'icon-5'
			}
			return msg
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		// 表格展示数据
		tableList() {
			let arr = [
				{
					sname: '合计(项目数)',
					id: '1000000',
					field: 'total',
					fieldId: 'totalId',
					parentName: '',
				},
				{
					sname: '计划编排类别',
					id: '1000001',
					field: '',
					fieldId: '',
					index: 2,
					children: [
						{
							sname: '续建项目',
							field: 'plan3',
							fieldId: 'planId3',
							id: '1000001002',
							index: 2,
							parentName: '计划编排类别',
						},
						{
							sname: '新建项目',
							field: 'plan1',
							fieldId: 'planId1',
							id: '1000001001',
							parentName: '计划编排类别',
							index: 1,
						},
						{
							sname: '开展前期',
							field: 'plan2',
							fieldId: 'planId2',
							id: '1000001003',
							index: 3,
							parentName: '计划编排类别',
						},
					],
				},
				{
					sname: '进展状态',
					id: '1000002',
					needTemplate: true,
					children: [
						{
							sname: '滞后',
							field: 'schedule3',
							fieldId: 'scheduleId3',
							id: '1000002001',
							index: 4,
							parentName: '进展状态',
						},
						{
							sname: '提前',
							field: 'schedule1',
							fieldId: 'scheduleId1',
							id: '1000002002',
							index: 5,
							parentName: '进展状态',
						},
						{
							sname: '持平',
							field: 'schedule2',
							fieldId: 'scheduleId2',
							id: '1000003003',
							index: 6,
							parentName: '进展状态',
						},
					],
				},
				{
					sname: '建设类型',
					id: '1000003',
					children: [
						{
							sname: '城市综合承载力提升建设',
							field: 'type1',
							fieldId: 'typeId1',
							id: '1000002001',
							index: 4,
							parentName: '建设类型',
						},
						{
							sname: '城市更新行动建设',
							field: 'type2',
							fieldId: 'typeId2',
							id: '1000002002',
							index: 5,
							parentName: '建设类型',
						},
						{
							sname: '公共服务设施',
							field: 'type3',
							fieldId: 'typeId3',
							id: '1000003003',
							index: 6,
							parentName: '建设类型',
						},
					],
				},
			]
			return arr
		},
		// list
		typeList() {
			return function (type) {
				let arr = this.$utils.clone(this.projectDict[type], true)
				let obj = {
					sname: '全部',
					value: '',
				}
				if (arr) {
					obj.value = arr.map((x) => x.value)
					arr.unshift(obj)
				}
				return arr
			}
		},

		// 标题旁边的提示语
		titleTip() {
			let msg = `数据统计说明：默认展示本年度月份数据统计，当选择其他年月数据时，则展示其他年度数据统计。
						</br>
						</br>
						本年度项目：有计划开竣工时间，且时间范围在本年度的，无实际竣工时间都纳入本年度项目统计。
						有计划开竣工时间，且实际竣工时间为本年度的，本年纳入统计，第二年不统计。
						</br>
						</br>
						初始数据统计：25号之前显示本年度上月数据。25号之后显示本年度本月数据。`
			return msg
		},
	},
	watch: {},
}
</script>
<style lang='less' scoped>
.VisualProcess-layout {
	height: 100%;
	.primary-layout {
		z-index: 9;
	}
	.bottom-layout {
		.primary-select {
			padding: 10px 0;
			display: flex;
			.title {
				font-size: 14px;
				min-width: 135px;
			}
		}
	}
	.left-text {
		/deep/.el-date-editor {
			margin: 0 10px !important;
		}
	}
	.content-table {
		height: calc(~'100% - 75px - 45px');
	}
	.w-table-page {
		padding-bottom: 20px;
	}
	.el-checkbox {
		margin-right: 15px;
	}
	.tips {
		color: #e6a23c;
		font-size: 16px;
		margin-left: 2px;
	}
	.margin-top25 {
		margin-top: 10px;
	}
	.height32 {
		height: 32px;
	}
	.custom-cell {
		font-size: 16px;
		cursor: pointer !important;
	}
	.custom-cell:hover {
		color: #27a9ff;
	}
	.tq {
		display: inline-block;
		padding: 4px 6px;
		color: #67c23a;
		background: #f0f9eb;
		border: 1px solid #c2e7b0;
		border-radius: 6px;
		min-width: 75px;
	}
	.zh {
		display: inline-block;
		padding: 4px 6px;
		color: #f56c6c;
		background: #fef0f0;
		border: 1px solid #fbc4c4;
		border-radius: 6px;
		min-width: 75px;
	}
	.cp {
		display: inline-block;
		padding: 4px 6px;
		color: #60adf9;
		background: #eff7fe;
		border: 1px solid #bfdefd;
		border-radius: 6px;
		min-width: 75px;
	}
	.common-style-icon {
		font-size: 16px;
		vertical-align: text-bottom;
	}
	.icon-1 {
		color: #c8c8c8 !important;
		.common-style-icon();
	}
	.icon-2 {
		color: #eea51a !important;
		.common-style-icon();
	}
	.icon-3 {
		color: #89c139 !important;
		.common-style-icon();
	}
	.icon-4 {
		color: #00b9e3 !important;
		.common-style-icon();
	}
	.icon-5 {
		color: #3bc7a1 !important;
		.common-style-icon();
	}
}
</style>
<style lang="less">
.bgcIndex1-progress {
	background-color: #e0ebf8 !important;
}
.bgcIndex2-progress {
	background-color: #e6f9e6 !important;
}
.bgcIndex3-progress {
	background-color: #fff0e1 !important;
}
</style>